import { FundsIcon, TemperatureIcon, VoltageIcon, OrderIcon } from "../Assets/images/svgs";
import { getDateEnd, getDateStart, getYearStart, manipulateDate } from "./datetime";
import PATHS from "../Routes/paths";

export const GOOGLE_MAPS_API_KEY = "AIzaSyA8DCzXebyD6dbPgauOIPcdMDgqhcaOtBg";
// AIzaSyDu-t6evx86x5OZEt2-ZXSVt_jFziL7wTY prod map api key
export const ONE_DAY_MS = 86400000;

export const CO2_EMISSION_PER_KM = 0.03;
export const MANUFATURING_CO2_EMISSION_PER_KM = 0.05;

export const SETTING_ROUTES = {
  PROFILE: { idx: 1, path: PATHS.PROFILE },
  CLIENTS: { idx: 2, path: PATHS.CLIENTS },
  MODELS: { idx: 3, path: PATHS.MODELS },
};

export const ICON_MAP = {
  VOLTAGE:        <VoltageIcon />,
  TEMPERATURE:    <TemperatureIcon />,
  FUND:           <FundsIcon />,
  ORDER:          <OrderIcon />,
};

export const NOTIF_TYPES = {
  101:    { label:   "Low Battery Voltage L1",         icon: ICON_MAP.VOLTAGE },
  102:    { label:   "Low Battery Voltage L2",         icon: ICON_MAP.VOLTAGE },
  103:    { label:   "High Battery Voltage L1",        icon: ICON_MAP.VOLTAGE },
  104:    { label:   "High Battery Voltage L2",        icon: ICON_MAP.VOLTAGE },
  201:    { label:   "Low Battery Temperature L1",     icon: ICON_MAP.TEMPERATURE },
  202:    { label:   "Low Battery Temperature L2",     icon: ICON_MAP.TEMPERATURE },
  203:    { label:   "High Battery Temperature L1",    icon: ICON_MAP.TEMPERATURE },
  204:    { label:   "High Battery Temperature L2",    icon: ICON_MAP.TEMPERATURE },
  301:    { label:   "New Order",                      icon: ICON_MAP.ORDER },
  302:    { label:   "Order Received",                 icon: ICON_MAP.ORDER },
  303:    { label:   "Fund Received",                  icon: ICON_MAP.FUND },
};

export const DATE_OPTIONS = {
  YESTERDAY:    1,
  LAST_7_DAYS:  2,
  LAST_30_DAYS: 3,
  THIS_YEAR:    4,
  LIFETIME:     5,
  CUSTOM:       6,
}

export const DEFAULT_DATE = DATE_OPTIONS.LAST_7_DAYS;

export const DATE_RANGES = {
  [DATE_OPTIONS.YESTERDAY]:      { from: getDateStart(manipulateDate({ days: -1 })),  to: getDateEnd(manipulateDate({ days: -1 })) },
  [DATE_OPTIONS.LAST_7_DAYS]:    { from: getDateStart(manipulateDate({ days: -7 })),  to: getDateEnd(manipulateDate({ days: -1 })) },
  [DATE_OPTIONS.LAST_30_DAYS]:   { from: getDateStart(manipulateDate({ days: -30 })), to: getDateEnd(manipulateDate({ days: -1 })) },
  [DATE_OPTIONS.THIS_YEAR]:      { from: getYearStart(), to: Date.now() },
  [DATE_OPTIONS.LIFETIME]:       { from: 1, to: Date.now() },
  [DATE_OPTIONS.CUSTOM]:         {},
};

export const CONNECTOR_TYP = {
  "Enderson" : 1,
  "C13" : 2,
  "SB75" : 3,
  "Chagori" : 4,
}

export const CHARGING_TYP = {
  "Exiom" : 1,
  "Enigma" : 2,
  "Spnatala" : 3,
  "Other": 4,
}

export const CHARGING_TYP_REV_MAP = {
  1: "Exiom",
  2: "Enigma",
  3: "Spnatala",
  4: "Other",
}

export const CONNECTOR_TYP_REV_MAP = {
  1: "Enderson",
  2: "C13",
  3: "SB75",
  4: "Chagori",
}

export const CAN_FAULT_FEEDBACK_MAP = {
  0: "Working Fine",
  1: "Drive Fault",
  2: "Hall Sensor Fault",
  3: "High Current Fault",
  4: "High Load Fault",
  5: "High Motor Temperature Fault",
  6: "High Speed Fault",
  7: "High Temperature Fault",
  8: "High Voltage Fault",
  9: "Low Voltage Fault",
  10: "MOSFET Fault",
  11: "Motor Blocking Fault",
  12: "Motor Lost Hall Fault",
  13: "Motor Phase Loss Fault",
  14: "Motor Stuck Fault",
  15: "Throttle Fault",
}

export const PAYMENT_MODES = {
  1: "Cash",
  2: "UPI",
  3: "Cheque",
  4: "Bank Transfer"
}

export const PAYMENT_MODE_VALUES = {
  CASH: 1,
  UPI: 2,
  CHEQUE: 3,
  BANK_TRANSFER: 4
};

export const ORDER_STATUS = {
  1: "Order Placed",
  1.1: "PI Raised",
  2: "Order Cancelled",
  3: "Payment Done",
  4: "Order Accepted",
  5: "Device Added In Stock",
};

export const ORDER_STATUS_VAL = {
  "Order Placed": 1,
  "PI Raised": 1.1,
  "Order Cancelled": 2,
  "Payment Done": 3,
  "Order Accepted": 4,
  "Device Added In Stock": 5,
};

// export const ORDER_STATUS_THEME_COLORS = {
//   1: "#B28101",
//   2: "#DEC15B",
//   3: "#C55151",
//   4: "#7CC1CA",
//   5: "#7FC549",
// };

// export const ORDER_STATUS_COLORS = {
//   1: "#B28101",
//   1.1: "#FCB704",
//   2: "#DEC15B",
//   3: "#FE5151",
//   4: "#99F3FF",
//   5: "#7FC549",
// };

export const ORDER_TIMELINE_STATUSES = [
  { idx: 1, nm: "Order Placed" },
  { idx: 1.1, nm: "PI Raised" },
  { idx: 2, nm: "Order Cancelled" },
  { idx: 3, nm: "Payment Done" },
  { idx: 4, nm: "Order Accepted" },
  { idx: 5, nm: "Device Added In Stock" },
];

export const ORDER_STATUS_VALS = {
  1: { label: "Order Placed", color: "#B28101", themeColor: "#B28101" },
  1.1: { label: "PI Raised", color: "#FCB704", themeColor: "#FCB704" },
  2: { label: "Order Cancelled", color: "#DEC15B", themeColor: "#DEC15B" },
  3: { label: "Payment Done", color: "#C55151", themeColor: "#C55151" },
  4: { label: "Order Accepted", color: "#99F3FF", themeColor: "#7CC1CA" },
  5: { label: "Device Added In Stock", color: "#7FC549", themeColor: "#7FC549" },
};

export const SHIPMENT_STATUS = {
  1: "Shipment Requested",
  2: "Shipped",
  3: "Delivered",
  4: "Cancelled",
}

export const SHIPMENT_STATUS_COLORS = {
  1: "#B28101",
  2: "#DEC15B",
  3: "#7FC549",
}

export const VENDORS = [ { value: 1, label: "Ajjas" } ];

export const ORDER_STATUS_PI_RAISED = 1.1;
export const ORDER_STATUS_CANCELLED = 2;
export const ORDER_STATUS_PAYMENT_DONE = 3;
export const SHIPMENT_STATUS_SHIPPED = 3;
export const SHIPMENT_STATUS_CANCELLED = 4;

export const DRAWER_ACCESS_CODES = {
  DEALERS_OVERVIEW: 101,
  DEALER_MANAGEMENT: 201,
  INVENTORY_OVERVIEW: 301,
  ORDERS_OVERVIEW: 401,
  INSTALLATION_VIDEO: 501,
  SHIPMENT_OVERVIEW: 601,
  LIVE_TRACKING: 701,
  ALL_VEHICLE_STATS: 801,
  SET_ALERTS: 901,

  ANALYTICS: 1001,
  VEHICLE_ACTIVITY: 1101,
  ROUTES: 1201,
  SUB_USERS: 1301,
  LEASE: 2,
  SETTINGS: 3,
  DASHBOARD: 4,
  INVENTORY: 5,
  DEALER: 6,
  ORDERS: 7,
};

export const SUBDEALERS_DES = 2;
export const SELLER_DES = 6;

export const SPN_IDS = {
  1: { nm: "Vodafone Idea" },
  2: { nm: "Vodafone Idea" },
  3: { nm: "Airtel" },
  4: { nm: "Vodafone Idea" },
}

export const PING_TEST_STATUS = {
  1: "Tested",
  2: "In Progress",
}

export const PING_TEST_STATUS_VAL = {
  "Tested": 1,
  "In Progress": 2,
}

export const MAX_RESPONSIVE_BREAKPOINT_WIDTH = 900;

export const DEVICE_INSTALLATION_TIMELINE_STATUSES = [
  { idx:1, nm: "Device Installation" },
  { idx:2, nm: "Ping Test" },
  { idx:3, nm: "Immobilisation Test" },
  { idx:4, nm: "Device Mapping" },
];

export const DEVICE_INSTALLATION_TIMELINE_STATUSES_VAL = {
  1: { label: "Device Installation", color: "#007AFF" },
  2: { label: "Ping Test", color: "#007AFF" },
  3: { label: "Immobilisation Test", color: "#007AFF" },
  4: { label: "Device Mapping", color: "#007AFF" },
};

export const DEV_INSTALLATION_STEPS = {
  DEVICE_INSTALLATION: 1,
  PING_TEST: 2,
  IMMOBILISATION_TEST: 3,
  DEVICE_MAPPING: 4,
}

export const SHIPMENT_STATUSES = [
  { idx:1, nm: "Shipment Requested", includeInCancelTimeline: true },
  { idx:2, nm: "Shipped" },
  { idx:3, nm: "Delivered" },
  { idx:4, nm: "Cancelled", includeInCancelTimeline: true, cancel: true },
];

export const SHIPMENT_STATUSES_VAL = {
  1: { label: "Shipment Requested" },
  2: { label: "Shipped" },
  3: { label: "Delivered" },
  4: { label: "Cancelled" },
};

export const SHIPPING_STATUSES = {
  "Shipment Requested": 1,
  "Shipped": 2,
  "Delivered": 3,
  "Cancelled": 4,
}

export const RELAY_STATES = {
  "LOCKED": 1,
  "UNLOCKED": 0,
}

function generateConstants(deviceArray) {
  const DEV_TYPE_VALUES = {};
  const DEV_TYPES = {};
  const DEVICE_TYPES = [];
  const DEVICE_TYPES_VALS = {};

  deviceArray.forEach((device, index) => {
    const value = index + 1;
    const { label, price } = device;

    DEV_TYPE_VALUES[label] = value;
    DEV_TYPES[value] = label;
    DEVICE_TYPES.push({ value, label });
    DEVICE_TYPES_VALS[value] = { nm: label, price };
  });

  return { DEV_TYPE_VALUES, DEV_TYPES, DEVICE_TYPES, DEVICE_TYPES_VALS };
}

const deviceArray = [
  { label: "Ajjas", price: 1000 },
  { label: "Ajjas (500 mAh Battery)", price: 1500 },
  { label: "Ajjas (1200 mAh Battery)", price: 2000 },
];

export const { DEV_TYPE_VALUES, DEV_TYPES, DEVICE_TYPES, DEVICE_TYPES_VALS } = generateConstants(deviceArray);
export const RIDING_SCORE_COLORS = {
  "Excellent" : "#6AB258",
  "Average": "#F9793E",
  "Poor": "#D34747",
}

export const OVERSPEED_TRIGGER_TYPE = 1;
export const GEOFENCE_TRIGGER_TYPE = 2;

export const SHARING_PATH = "/tlshared";

export const DEVICE_HWTYP_VALUES = {
  1: "Wired",
  2: "Wireless",
  3: "Lite",
}

export const DEVICE_HWTYPS = {
  "Wired": 1,
  "Wireless": 2,
  "Lite": 3,
}

export const FUEL_TYPES = {
  1: "Petrol",
  2: "Diesel",
  3: "Electric",
  4: "CNG",
};

export const LOGIN_REDIRECT_PATHS = {
  101: PATHS.DEALERS_OVERVIEW,
  201: PATHS.DEALERS_OVERVIEW,
  301: PATHS.INVENTORY_OVERVIEW,
  401: PATHS.ORDERS_OVERVIEW,
  501: PATHS.INSTALLATION_VIDEO,
  601: PATHS.SHIPMENT_OVERVIEW,
  701: PATHS.LIVE_TRACKING,
  801: PATHS.ALL_VEHICLE_STATS,
  901: PATHS.SET_ALERTS,
  1001: PATHS.ANALYTICS,
  1101: PATHS.VEHICLE_ACTIVITY,
  1201: PATHS.VIEW_ROUTES,
  1301: PATHS.SUB_USERS,
}
export const RELAY_TEST_STATUS_VAL = 3;

export const SPN_IDS_MAP = {
  1: "Vodafone Idea",
  2: "Vodafone Idea",
  3: "Airtel",
  4: "Vodafone Idea",
};

export const SPEED_ALERTS_TITLE = "Speed Alerts";
export const GEOFENCE_NOTIFICATION_TYPE = 202;

export const VEHICLE_TYPES = {
  1: "Two wheeler",
  2: "Four wheeler",
  3: "Auto rickshaw",
  4: "Heavy vehicle",
  5: "Others",
  6: "Public Transport",
  7: "Cycle",
  8: "No Vehicle",
  9: "Electric Vehicle (EV)",
};

export const VEHICLE_ICON_URLS = {
  "Two wheeler": {
    NORMAL: "https://img.ajjas.com/images/web_assets/BIKE_NORMAL.png",
    MOTION: "https://img.ajjas.com/images/web_assets/BIKE_MOTION.png",
    IGNITION: "https://img.ajjas.com/images/web_assets/BIKE_IGNITION.png",
    POWER_OFF: "https://img.ajjas.com/images/web_assets/BIKE_POWER_OFF.png",
  },
  "Four wheeler": {
    NORMAL: "https://img.ajjas.com/images/web_assets/CAR_NORMAL.png",
    MOTION: "https://img.ajjas.com/images/web_assets/CAR_MOTION.png",
    IGNITION: "https://img.ajjas.com/images/web_assets/CAR_IGNITION.png",
    POWER_OFF: "https://img.ajjas.com/images/web_assets/CAR_POWER_OFF.png",
  },
  "Heavy vehicle": {
    NORMAL: "https://img.ajjas.com/images/web_assets/HEAVY_VEH_NORMAL.png",
    MOTION: "https://img.ajjas.com/images/web_assets/HEAVY_VEH_MOTION.png",
    IGNITION: "https://img.ajjas.com/images/web_assets/HEAVY_VEH_IGNITION.png",
    POWER_OFF: "https://img.ajjas.com/images/web_assets/HEAVY_VEH_POWER_OFF.png",
  }
}

export const BIKE_NORMAL_ICON = "https://img.ajjas.com/images/web_assets/BIKE_NORMAL.png";
export const VEHICLE_TYPE_BIKE = 1;

export const ANALYTICS_DASHBOARD_ACC_CODE = 1001;

export const VEH_FIL_CT = [
  { idx: 1, label: "Less than", value: 0 },
  { idx: 2, label: "More than", value: 1 },
  { idx: 3, label: "Less than equals", value: 2 },
  { idx: 4, label: "More than equals", value: 3 },
]

export const SUB_USER_FEATURES = [
  { idx: 1, value: 701, label: "Live Tracking" },
  { idx: 2, value: 801, label: "Staistics" },
  { idx: 3, value: 901, label: "Set Alerts" },
];